interface StatusBannerProps {
  wsStatus: 'connecting' | 'connected' | 'disconnected';
  relayBridgeUp: boolean;
  companionUp: boolean;
  isStale: boolean;
  canControl: boolean;
  error: string | null;
}

export function StatusBanner({
  wsStatus,
  relayBridgeUp,
  companionUp,
  isStale,
  canControl,
  error,
}: StatusBannerProps) {
  if (error) {
    return <div className="banner banner-error">{error}</div>;
  }

  if (wsStatus === 'connecting') {
    return <div className="banner banner-info">Connecting...</div>;
  }

  if (wsStatus === 'disconnected') {
    return (
      <div className="banner banner-error">
        Cannot connect to relay — close and reopen the app
      </div>
    );
  }

  if (!relayBridgeUp) {
    return <div className="banner banner-error">Control unavailable — bridge offline</div>;
  }

  if (!companionUp) {
    return <div className="banner banner-error">Control unavailable — Companion disconnected</div>;
  }

  if (isStale) {
    return <div className="banner banner-error">Control unavailable — state stale</div>;
  }

  if (!canControl) {
    return <div className="banner banner-info">View only — you do not have control access</div>;
  }

  return null;
}
